<template>
  <div class="zhanwei4"></div>
  <h1 class="title">时间积分</h1>
  <el-form
    :model="form"
    label-width="auto"
    label-position="top"
    style="padding: 40px"
  >
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="游戏标准时长（分钟）">
          <el-input type="number" clearable v-model="form.gameTime" disabled />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="超时扣分">
          <el-input type="number" clearable v-model="form.timeoutDeducted" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="满分">
          <el-input type="number" clearable v-model="form.fullMarks" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="多长时间内过关满分（分钟）">
          <el-input type="number" clearable v-model="form.parlayTime" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="关卡积分">
          <el-input type="number" clearable v-model="form.levelPoints" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="每次答错积分">
          <el-input type="number" clearable v-model="form.incorrectAnswer" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="关卡数量">
          <el-input
            type="number"
            clearable
            v-model="form.numberLevel"
            disabled
          />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="使用提示扣分">
          <el-input type="number" clearable v-model="form.promptsDeduct" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item label="跳过过关扣分">
          <el-input type="number" clearable v-model="form.skippingParlay" />
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item label="使用地点求救扣分">
          <el-input type="number" clearable v-model="form.sosPoints" />
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 结算看板卡片 -->
    <div class="score-calculation-card">
      <div class="calc-header">
        <span class="calc-title">游戏最高得分结算规则</span>
        <span class="calc-formula-desc"
          >时间分数(满分) + 关卡积分 × 关卡数</span
        >
      </div>

      <div class="calc-display-box">
        <div class="formula-process">
          <span class="num-badge">{{ form.fullMarks || 0 }}</span>
          <span class="operator">+</span>
          <span class="num-badge">{{ form.numberLevel || 0 }}</span>
          <span class="operator">×</span>
          <span class="num-badge">{{ form.levelPoints || 0 }}</span>
          <span class="operator">=</span>
        </div>
        <div class="total-score-value">
          <span class="label">最高理论得分</span>
          <span class="score-number">{{ totalPoint || 0 }}</span>
        </div>
      </div>

      <div class="btn-action-row">
        <el-button
          type="primary"
          size="large"
          class="save-btn"
          @click="saveSettings"
        >
          保存积分规则
        </el-button>
      </div>
    </div>
  </el-form>
  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { ElMessage } from "element-plus";
import { defineComponent } from "vue";

export default defineComponent({
  name: "IntegralSetting",
  data(): any {
    return {
      gameId: "",
      form: {
        id: "",
        gameTime: 0,
        timeoutDeducted: 0,
        parlayTime: 0,
        fullMarks: 0,
        levelPoints: 0,
        incorrectAnswer: 0,
        numberLevel: 0,
        promptsDeduct: 0,
        skippingParlay: 0,
        sosPoints: 0,
      },
    };
  },
  computed: {
    totalPoint(): number {
      const fullMarks = parseInt(this.form.fullMarks, 10) || 0;
      const numberLevel = parseInt(this.form.numberLevel, 10) || 0;
      const levelPoints = parseInt(this.form.levelPoints, 10) || 0;
      return fullMarks + numberLevel * levelPoints;
    },
  },
  mounted() {
    const { id } = this.$route.params;
    this.gameId = id as string;
    this.initRelease(this.gameId);
  },
  methods: {
    initRelease(id: string) {
      this.$store
        .dispatch("game/getBonus", { gameId: id })
        .then((res: any) => {
          if (res) {
            this.form = res;
          }
        })
        .catch((err: any) => {
          console.error(err);
        });
    },
    saveSettings() {
      this.$store
        .dispatch("game/updateBonus", { integralBean: this.form })
        .then((res: any) => {
          ElMessage.success("保存成功");
        })
        .catch((err: any) => {
          ElMessage.error("保存失败: " + err);
        });
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;

.zhanwei4 {
  height: 24px;
}

.zhanwei3 {
  height: 32px;
}

.title {
  max-width: 960px;
  margin: 0 auto 20px;
  padding: 0 10px;
  font-size: 20px;
  font-weight: 700;
  color: @text-main;
  letter-spacing: 0.5px;
}

:deep(.el-form) {
  max-width: 960px !important;
  margin: 0 auto !important;
  padding: 32px 36px;
  background-color: #ffffff;
  border: 1px solid @card-border;
  border-radius: 16px;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04),
    0 2px 6px -1px rgba(15, 23, 42, 0.02);
  box-sizing: border-box;

  .el-form-item {
    margin-bottom: 22px;

    .el-form-item__label {
      font-size: 13px;
      font-weight: 600;
      color: @text-main;
      padding-bottom: 6px;
    }
  }

  .el-input__wrapper {
    border-radius: 8px;
    box-shadow: 0 0 0 1px @border-color inset;
    padding: 4px 14px;
    transition: all 0.2s ease;

    &:hover {
      box-shadow: 0 0 0 1px #cbd5e1 inset;
    }

    &.is-focus {
      box-shadow: 0 0 0 1px @primary-color inset !important;
    }

    &.is-disabled {
      background-color: #f8fafc;
      box-shadow: 0 0 0 1px @border-color inset;

      .el-input__inner {
        color: @text-muted;
        -webkit-text-fill-color: @text-muted;
        font-weight: 500;
      }
    }
  }
}

.score-calculation-card {
  margin-top: 16px;
  padding: 24px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid @border-color;
  box-sizing: border-box;

  .calc-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .calc-title {
      font-size: 15px;
      font-weight: 700;
      color: @text-main;
    }

    .calc-formula-desc {
      font-size: 12px;
      color: @text-muted;
    }
  }

  .calc-display-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    border-radius: 10px;
    padding: 16px 20px;
    border: 1px solid @border-color;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);

    @media (max-width: 640px) {
      flex-direction: column;
      gap: 14px;
      align-items: flex-start;
    }

    .formula-process {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      font-weight: 600;

      .num-badge {
        background: #f1f5f9;
        color: @text-main;
        padding: 4px 10px;
        border-radius: 6px;
        border: 1px solid #e2e8f0;
      }

      .operator {
        color: @text-muted;
        font-weight: bold;
      }
    }

    .total-score-value {
      display: flex;
      align-items: baseline;
      gap: 8px;

      .label {
        font-size: 12px;
        color: @text-sub;
        font-weight: 500;
      }

      .score-number {
        font-size: 26px;
        font-weight: 800;
        color: @primary-color;
        line-height: 1;
      }
    }
  }

  .btn-action-row {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;

    .save-btn {
      min-width: 150px;
      height: 42px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      background: @primary-color;
      border-color: @primary-color;
      box-shadow: 0 4px 14px rgba(93, 95, 239, 0.28);
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: #4b4de0;
        border-color: #4b4de0;
        transform: translateY(-2px);
        box-shadow: 0 6px 18px rgba(93, 95, 239, 0.38);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}
</style>
